"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
var react_1 = __importDefault(require("react"));
var Box_1 = require("./Box");
var HiddenNativeInput_1 = require("./common/HiddenNativeInput");
var core_1 = require("./core");
function Switch(_a) {
    var _b = _a.activeColor, activeColor = _b === void 0 ? '$indigo' : _b, checked = _a.checked, _c = _a.inactiveColor, inactiveColor = _c === void 0 ? '$grey4' : _c, onChange = _a.onChange;
    return (react_1.default.createElement(Box_1.Box, { as: 'label', background: checked ? activeColor : inactiveColor, borderRadius: '$circle', center: true, clickable: true, height: switchHeight, onMouseUp: preventFocus, width: switchWidth },
        react_1.default.createElement(Handle, { background: '$white', borderRadius: '$circle', checked: checked }),
        react_1.default.createElement(HiddenNativeInput_1.HiddenNativeInput, { checked: checked, onChange: function (event) { return onChange(event.target.checked); }, role: 'switch', type: 'checkbox' })));
}
exports.Switch = Switch;
var switchWidth = (0, core_1.getCustomSize)(20);
var switchHeight = (0, core_1.getCustomSize)(12);
var Handle = (0, core_1.styled)(Box_1.Box, {
    '--handleSize': "calc(".concat(switchHeight, " - 2 * space.$2px)"),
    '--handleOffset': "calc((".concat(switchWidth, " - var(--handleSize)) / 2 - space.$2px)"),
    'height': 'var(--handleSize)',
    'transform': 'translateX(calc(-1 * var(--handleOffset)))',
    'transition': 'transform 100ms',
    'width': 'var(--handleSize)',
}, { checked: { true: { transform: 'translateX(var(--handleOffset))' } } });
function preventFocus(event) {
    var _a;
    event.preventDefault();
    (_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.blur();
}
